const getVideoId = (link: string): string | null => {
  if (link.includes('youtu.be/')) {
    const match = link.match(/youtu\.be\/([^?&]+)/);
    return match ? match[1] : null;
  }

  if (link.includes('youtube.com/watch')) {
    const match = link.match(/[?&]v=([^&]+)/);
    return match ? match[1] : null;
  }

  if (link.includes('youtube.com/embed/')) {
    const match = link.match(/youtube\.com\/embed\/([^?&]+)/);
    return match ? match[1] : null;
  }

  return link.slice(-11);
};

export default getVideoId;
